export const colors = {
    BLUE: "#008EC8",
    GREY:"#606C73",
    ORANGE:"#DB6727",
    LIGHT_ORANGE: "#E5AD4D",
    YELLOW: "#FFE000",
};
